import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import { AxiosPromise } from 'axios'

export type WarningQueryType = {
  create_end_date: string
  create_start_date: string
  is_use_review: number
  page: number
  page_size: number
  update_end_date: string
  update_start_date: string
  third_tag_code: number[]
}
export type WarningListType = {
  id: number
  admin_id: number
  admin_name: string
  created_time: number
  first_tag: string
  first_tag_code: number
  is_use_review: number
  second_tag: string
  second_tag_code: number
  third_tag: string
  updated_time: number
  third_tag_code: number
}

export enum IsUseReviewEnum {
  YES = 1,
  NO = 2,
}

export const searchOptions: { value: IsUseReviewEnum; label: string }[] = [
  {
    value: IsUseReviewEnum.YES,
    label: '是',
  },
  {
    value: IsUseReviewEnum.NO,
    label: '否',
  },
]

export function getWarningList(params: WarningQueryType): AxiosPromise {
  return request({
    url: `${v2Host}/creative/warning/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 保存风险标签
 */
export function saveWarningInfo(data: {
  third_tag_code: number[]
  is_use_review: number
  is_use_rereview: number
}): AxiosPromise {
  return request({
    url: `${v2Host}/creative/warning/save`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/**
 * 更新风险标签
 */
export function updateWarningInfo(data: {
  is_use_review: number
  id: number
}): AxiosPromise {
  return request({
    url: `${v2Host}/creative/warning/update`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/**
 * 删除风险标签
 */
export function deleteWarningInfo(data: { id: number }): AxiosPromise {
  return request({
    url: `${v2Host}/creative/warning/delete`,
    method: 'post',
    data,
  })
}

/**
 * 获取推送阈值设置
 */
export function getRereviewSetting(): AxiosPromise {
  return request({
    url: `${v2Host}/creative/setting/rereview-setting`,
    method: 'get',
  })
}

/**
 * 修改推送阈值设置
 */
export function editRereviewSetting(data: {
  image: number
  pl: number
  video: number
}): AxiosPromise {
  return request({
    url: `${v2Host}/creative/setting/rereview-setting`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}

/**
 * 获取优先级设置
 */
export function getPrioritySetting(): AxiosPromise {
  return request({
    url: `${v2Host}/creative/setting/priority-setting`,
    method: 'get',
  })
}

/**
 * 修改优先级设置
 */
export function editPrioritySetting(data: {
  [x in number]: {
    image_max: number
    image_min: number
    pl_max: number
    pl_min: number
    video_max: number
    video_min: number
  }
}): AxiosPromise {
  return request({
    url: `${v2Host}/creative/setting/priority-setting`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}
